import { ApiBaseError, SimInventoryBaseErrorReturn, getStandardHeaders } from './shared';

interface DeleteFetcherProps {
  url: string;
  body: Object | null;
}

// TODO: Consider consolidating DELETE/PUT/POST

const deleteFetcher = async ({ url, body }: DeleteFetcherProps) => {
  const response = await fetch(url, {
    credentials: 'include',
    method: 'DELETE',
    body: body && JSON.stringify(body),
    headers: getStandardHeaders(),
  });

  if (!response.ok) {
    const error: ApiBaseError = new Error('An error occurred while deleting the data.');
    error.info = (await response.json()) as SimInventoryBaseErrorReturn;
    error.status = response.status;
    throw error;
  }

  const resultJson = await response.json();
  return resultJson;
};

export default deleteFetcher;
